import PropTypes from 'prop-types';
import StyledLink from './styles';

const Link = ({ children, disabled, ...props }) => (
  <StyledLink
    {...props}
    disabled={disabled}
    onClick={(e) => {
      if (disabled) {
        e.preventDefault();
        e.stopPropagation();
      } else if (props.onClick) {
        props.onClick(e);
      }
    }}
  >
    {children}
  </StyledLink>
);

Link.propTypes = {
  color: PropTypes.string,
  children: PropTypes.node,
  disabled: PropTypes.bool,
};

export default Link;
